import { ChevronDown } from 'src/shared/design-system/Icon';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';
import { Border, Colors, Font, ScreenWidth, Transition } from 'web-common/src/shared/styles';
import { DropdownSize } from '../consts';
import { THEME } from '../theme';

export const Wrapper = styled.div`
  flex: 1 1 100%;
  white-space: break-word;
`;

export const InputOverlay = styled.div<{ isOpen?: boolean }>`
  ${ifProp(
    'isOpen',
    css`
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      pointer-events: all;
    `,
    css`
      display: none;
      pointer-eventers: none;
    `
  )}
`;

export const DropdownInput = styled.input<{ disabled?: boolean; dropdownSize: DropdownSize }>`
  box-sizing: border-box;
  border: ${Border.BaseDouble} ${Colors.EGGPLANT_100};
  color: ${Colors.EGGPLANT};
  flex: 1;
  font-family: ${Font.Family.SANS} !important;
  font-size: ${({ dropdownSize }) => THEME[dropdownSize].FontSize} !important;
  font-weight: 400;
  line-height: ${({ dropdownSize }) => THEME[dropdownSize].FontSize};
  outline: none;
  margin: 0;
  padding: ${({ dropdownSize }) =>
    `calc(${THEME[dropdownSize].Padding} + 1px) ${THEME[dropdownSize].Padding} calc(${THEME[dropdownSize].Padding} - 1px) ${THEME[dropdownSize].Padding}`};
  max-width: auto;
  background: ${Colors.MILK};
  transition: border ${Transition.Time.BASE}, background ${Transition.Time.BASE}, color ${Transition.Time.BASE};

  &::placeholder {
    color: ${Colors.EGGPLANT_200};
  }

  ${ifProp(
    'disabled',
    css`
      background-color: ${Colors.MILK} !important;
      cursor: not-allowed !important;
      color: ${Colors.EGGPLANT_200};

      &::placeholder {
        color: ${Colors.EGGPLANT_200};
      }

      &:hover:not([aria-expanded='true']) {
        border-color: ${Colors.EGGPLANT_100} !important;
        background-color: ${Colors.MILK};
      }
    `,
    css`
      &[readonly] {
        cursor: pointer;
      }

      &:hover:not([aria-expanded='true']) {
        border-color: ${Colors.EGGPLANT_200};
        background-color: ${Colors.MILK};
      }

      &[aria-expanded='true'] {
        border-color: ${Colors.EGGPLANT};
      }
    `
  )};
`;

export const IconContainer = styled.div<{ isOpen?: boolean; selected?: boolean; size: DropdownSize }>`
  align-items: center;
  color: ${ifProp('selected', Colors.RADISH, Colors.EGGPLANT)};
  display: flex;
  padding: ${({ size }) => THEME[size].Padding};
  pointer-events: none;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  transform: ${ifProp('isOpen', 'rotate(-180deg)', 'rotate(0deg)')};
  transition: transform ${Transition.Time.BASE};

  & svg {
    box-sizing: content-box !important;
    height: ${({ size }) => THEME[size].IconSize};
    width: ${({ size }) => THEME[size].IconSize};
  }
`;

export const Icon = styled(ChevronDown)``;

export const MobileSelect = styled.select`
  display: none;
  position: absolute;
  opacity: 0;
  pointer-events: none;

  @media (max-width: ${ScreenWidth.SMALL}) {
    display: block;
    pointer-events: all;
    height: 100%;
    width: 100%;
  }
`;
